export default __webpack_public_path__ + "static/7-f39f658d603b77f6d4cb27e173fd809b.png";